// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__S27fY","subheader":"ReorderModal_subheader__2fubG","listWrap":"ReorderModal_listWrap__2Atal"};